// @flow
import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';

import Sidebar from 'components/sidebar/Sidebar';
import CardThumbnail from 'containers/fragments/CardThumbnailContainer';
import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';

import type { BlocContent } from 'types/NewsletterBloc';
import type { CardType } from 'types/PageList';
import type { PageChildType } from 'types/PageNode';

type Props = {
  sidebar_content: BlocContent[],
  liste_enfants: PageChildType[]
};

type State = {
  practiceType: string[],
  practicesAudience: string[]
};

class PagePratiques extends Component<Props, State> {
  state = {
    practicesAudience: [],
    practiceType: []
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const { liste_enfants } = props;
    const { practiceType: practicesInState, practicesAudience: audienceInState } = state;
    const practicesAudience = [];
    const practiceType = [];

    if (liste_enfants.length > 0 && audienceInState.length < 1) {
      const publics = [];
      liste_enfants.map(({ types_public }) => {
        types_public.map(type => {
          if (publics.indexOf(type) === -1) {
            publics.push(type);
          }
          return '';
        });
        return '';
      });
      practicesAudience.push(...publics);
    }

    if (liste_enfants.length > 0 && practicesInState.length < 1) {
      practiceType.push(...liste_enfants.map<string>(({ title }) => title));
    }

    if (practicesAudience.length > 0 || practiceType.length > 0) {
      return {
        practicesAudience: [...practicesAudience, ...audienceInState],
        practiceType: [...practicesInState, ...practiceType]
      };
    }
    return null;
  }

  renderTeams = (cards: Array<CardType>): Array<any> => {
    return cards.map((card, index) => {
      let classNameContainer = 'col col-md-6';

      if (index === 1) {
        classNameContainer = 'col col-md-6';
      }

      return (
        <div key={index} className={classNameContainer}>
          <CardThumbnail
            url={card.object_slug}
            backgroundUrl={card.featured_media}
            title={card.title}
            desc={card.description}
            linkLabel={card.texte_cta}
            classAdd={'mb-2 mb-md-6'}
            isWide
          />
        </div>
      );
    });
  };

  renderSidebar = () => {
    const { sidebar_content } = this.props;

    return <Sidebar sidebarContent={sidebar_content} />;
  };

  renderPratiques = () => {
    const { liste_enfants } = this.props;
    const { practiceType, practicesAudience } = this.state;

    return liste_enfants
      .filter(({ title }) => practiceType.includes(title))
      .filter(({ types_public }) => {
        return practicesAudience.length > 0 ? types_public && types_public.some(item => practicesAudience.includes(item)) : true;
      })
      .map<any>((enfant, index) => {
        return (
          <Fragment key={enfant.object_id}>
            <h2 className="mb-2 mb-md-4">{enfant.title}</h2>
            <p className="mb-4 mb-md-6">{enfant.description}</p>
            <h3 className="mb-4">{enfant.texte_cta}</h3>
            {enfant.object_slug && (
              <Link to={enfant.object_slug} className="link-chevron link-chevron--right">
                <span>Voir toutes les équipes</span>
                <i className="icon icon-chevron-right"></i>
              </Link>
            )}
            {enfant.liste_enfants && enfant.liste_enfants.length > 0 && <div className="row">{this.renderTeams(enfant.liste_enfants)}</div>}
            <hr className="separator mb-5"></hr>
          </Fragment>
        );
      });
  };

  handleFilterChange = (value: string, type: string) => {
    if (this.state[type].includes(value)) {
      this.setState(prevState => {
        const withoutValue = prevState[type].filter(el => el !== value);
        return {
          ...prevState,
          [type]: withoutValue
        };
      });
    } else {
      this.setState(prevState => ({
        ...prevState,
        [type]: [...prevState[type], value]
      }));
    }
  };

  convertToOptions = () => {
    const { liste_enfants } = this.props;
    return liste_enfants.map<any>(({ title }) => ({ label: title, value: title }));
  };

  convertToPublicOptions = () => {
    const { liste_enfants } = this.props;
    const publicsOptions = [];
    const publics = [];
    liste_enfants.map(({ types_public }) => {
      types_public.map(type => {
        if (publics.indexOf(type) === -1) {
          publics.push(type);
          publicsOptions.push({ label: type, value: type });
        }
        return '';
      });
      return '';
    });
    return publicsOptions;
  };

  render() {
    const { practicesAudience, practiceType } = this.state;
    /**
     * Masquer les publics dans un premier temps cf : https://redmine.dev.ffr.fr/issues/5968
     */
    //const publicOptions = this.convertToPublicOptions();
    const publicOptions = false;
    return (
      <div className="row">
        <div className="col col-md-8 col-lg-9 bg-overflow">
          <section>
            <div className="header-filter header-filter--team header-filter--teamWfilter mt-2">
              <div className="row">
                <div className="col col-lg-8on9">
                  <div className="header-filter__left">
                    {publicOptions && publicOptions.length > 1 && (
                      <div className="multi-dropdown">
                        <DropdownMultiInput
                          className="dropdown dropdown--noBorder dropdown--checkbox"
                          selected={practicesAudience}
                          label="Pour tout le monde"
                          counter={0}
                          inputChanged={(value: string) => this.handleFilterChange(value, 'practicesAudience')}
                          id="practices-public"
                          options={publicOptions}
                          closeOnSelect={false}
                        />
                      </div>
                    )}
                    <div className="multi-dropdown">
                      <DropdownMultiInput
                        className="dropdown dropdown--noBorder dropdown--checkbox"
                        selected={practiceType}
                        label="Toutes les pratiques"
                        counter={0}
                        inputChanged={(value: string) => this.handleFilterChange(value, 'practiceType')}
                        id="practice-type"
                        options={this.convertToOptions()}
                        closeOnSelect={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="header-filter__sep mb-1" />
            <div className="row">
              <div className="col col-lg-8on9">
                <div className="page">{this.renderPratiques()}</div>
              </div>
            </div>
          </section>
        </div>
        {this.renderSidebar()}
      </div>
    );
  }
}

export default PagePratiques;
